export const RESUME_DESCRIPTION =
  "Automatically review resumes and extract key professional history into a structured format. Our AI verifies the document is a resume and parses work experience, education, and skills for faster evaluation.";
export const RESUME_EXAMPLE_USE_CASES =
  "Quickly assess qualifications, faster screening, consistent evaluation of work history.";
export const RESUME_COST = "$1.99 per verification";

export const RESUME_INSTRUCTIONS = `### **Requirement guide for resume** 
Upload a digital copy of your resume. Make sure all information is legible and matches the verification requirements below.

**Upload resume:**

- **Prepare your file**
  - Have a clear digital copy ready.
  - Check that all text is legible.
  - Review the verification details below to confirm your resume meets the requirements.

- **Upload your file**
  - Upload your file on the next page.

- **Accepted formats:**
  - Document (pdf)
  - Image (jpeg, png, webp, heic, heif)
  - Max 100MBs per file
`;

export const RESUME = {
  instructions: RESUME_INSTRUCTIONS,
  description: RESUME_DESCRIPTION,
  exampleUseCases: RESUME_EXAMPLE_USE_CASES,
  cost: RESUME_COST
};
